export default __webpack_public_path__ + "static/save-the-children-v2-183c698ae79f33830eef1d39081220c7.jpg";